<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <div class="rs-fe3"></div>
    <div class="row">
      <div class="columns small-12">
        <a
          href="javascript:void(0)"
          class="rs-btn rs-btn-third rs-btn-third-icon-left"
          (click)="routeToStep1()"
          ><i class="rs-icon-btn-third rs-margin-right1" aria-hidden="true"></i>
          {{ 'flexEmergency.common.back' | translate }}
        </a>

        <div class="rs-me"></div>
        <h1 class="rs-tit4">{{ 'flexEmergency.entry.title' | translate }}</h1>
        <p class="rs-tit6 rs-txt-c1 rs-padding-bottom2">
          {{ 'flexEmergency.confirmation.subtitle' | translate }}
        </p>
        <div class="panel rs-bg-purple1">
          <div class="rs-flex-row">
            <div class="rs-flex-column rs-flex-shrink">
              <i
                class="icon-Newsletter icon-lh rs-txt-primary rs-txt-s8 rs-margin-bottom2"
                aria-hidden="true"
              ></i>
            </div>
            <div class="rs-flex-column">
              <p class="rs-txt-details">
                {{ 'flexEmergency.confirmation.section1' | translate }}
              </p>
            </div>
          </div>
          <hr />
          <div class="rs-flex-row">
            <div class="rs-flex-column rs-flex-shrink">
              <i
                class="icon-Stopwatch icon-lh rs-txt-primary rs-txt-s8 rs-margin-bottom2"
                aria-hidden="true"
              ></i>
            </div>
            <div class="rs-flex-column">
              <p class="rs-txt-details">
                {{ 'flexEmergency.confirmation.section2' | translate }}
              </p>
            </div>
          </div>
          <hr />
          <div class="rs-flex-row">
            <div class="rs-flex-column rs-flex-shrink">
              <i
                class="icon-Contact icon-lh rs-txt-primary rs-txt-s8 rs-margin-bottom2"
                aria-hidden="true"
              ></i>
            </div>
            <div class="rs-flex-column">
              <p class="rs-txt-details">
                {{ 'flexEmergency.confirmation.section3' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="panel rs-bg-orange rs-bgt-7 rs-neg">
          <h2 class="rs-tit6">
            {{ 'flexEmergency.confirmation.share.title' | translate }}
          </h2>
          <p>
            {{ 'flexEmergency.confirmation.share.description' | translate }}
          </p>
          <a
            href="{{ 'flexEmergency.confirmation.ShowMe.link' | translate }}"
            class="rs-btn rs-btn-third"
            >{{ 'flexEmergency.confirmation.ShowMe' | translate
            }}<span class="show-for-sr"> {{ 'flexEmergency.confirmation.share' | translate }}</span>
            <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
          ></a>
        </div>
      </div>
    </div>
    <div class="rs-le2"></div>
  </main>
</section>
